import { render, staticRenderFns } from "./TrucksWithAlertsPanel.vue?vue&type=template&id=cfb9368c&scoped=true"
import script from "./TrucksWithAlertsPanel.vue?vue&type=script&lang=js"
export * from "./TrucksWithAlertsPanel.vue?vue&type=script&lang=js"
import style0 from "./TrucksWithAlertsPanel.vue?vue&type=style&index=0&id=cfb9368c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfb9368c",
  null
  
)

export default component.exports